import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

import { useHandleError } from "@/hooks/useHandleError";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { useCancelSetup } from "@/services/auth";

export const isNoSetupInProgressError = (error: AxiosError<any>) =>
  error.response?.data?.errorCode === 404;

/**
 * `useCancelSetup` that sends the customer back to the Login tab without an
 * error toast when the backend has no setup process left to cancel.
 */
export const useCancelTwoFactorSetup = (
  options?: Parameters<typeof useCancelSetup<AxiosError<any>>>[0],
) => {
  const navigate = useNavigate();
  const handleError = useHandleError();

  return useCancelSetup<AxiosError<any>>({
    ...options,
    mutation: {
      ...options?.mutation,
      onError: (error, variables, context) => {
        if (isNoSetupInProgressError(error)) {
          navigate(portalRoutes.user.security.base);

          return;
        }

        if (options?.mutation?.onError) {
          options.mutation.onError(error, variables, context);
        } else {
          handleError(error);
        }
      },
    },
  });
};
